import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { HouseOrderDetailComponent } from "@root/router/component/house-order-detail/house-order-detail.component";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";
import * as moment from "moment";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalService } from "ng-zorro-antd/modal";

type OrderType = "today_checkin" | "today_checkout" | "tomorrow_checkin" | "tomorrow_checkout";

@Component({
  selector: "host-recent-order-list",
  templateUrl: "./recent-order-list.component.html",
  styleUrls: ["./recent-order-list.component.scss"],
})
export class RecentOrderListComponent implements OnInit {
  private readonly ListApi = "/api/reservation_order/list";
  @Input() type: OrderType = "today_checkin";
  total = 0;
  page = 1;
  pageSize = 20;
  listOfOrder = [];

  get OrderListParams() {
    const today = moment().format("YYYY-MM-DD");
    const tomorrow = moment().add(1, "day").format("YYYY-MM-DD");
    const dateParams = [];
    if (this.type.endsWith("checkout")) {
      dateParams.push("check_out");
    } else if (this.type.endsWith("checkin")) {
      dateParams.push("check_in");
    }
    if (this.type.startsWith("today")) {
      dateParams.push(today);
    } else if (this.type.startsWith("tomorrow")) {
      dateParams.push(tomorrow);
    }

    return {
      format: "split_by_reservation",
      [dateParams[0]]: dateParams[1],
    };
  }

  constructor(
    private http: HttpClient,
    private msg: NzMessageService,
    private modal: NzModalService,
    private t: TranslateService,
    private orderService: OrderV2Service
  ) {}

  private fetchOrderList() {
    const params = {
      page: this.page,
      page_size: this.pageSize,
      ...this.OrderListParams,
    };

    this.http.get(this.ListApi, { params }).subscribe((rst: any) => {
      this.listOfOrder = rst?.data?.list;
      this.total = rst?.data?.count;
    });
  }

  ngOnInit() {
    this.fetchOrderList();
  }

  onPageChange(page) {
    this.fetchOrderList();
  }

  onClickReservation(code) {
    this.modal.create({
      nzTitle: this.t.t("word.order_detail"),
      nzContent: HouseOrderDetailComponent,
      nzFooter: null,
      nzWidth: 900,
      nzComponentParams: {
        code: code,
        pageType: "modal",
      },
    });
  }

  onClickCheckButton(reservation) {
    const { code, out_status } = reservation;
    let title, content;
    if (out_status === "wait_stay") {
      title = this.t.t("warning.order.confirm_check_in");
      content = this.t.t("warning.order.confirm_tenant_in");
    } else if (out_status === "staying") {
      title = this.t.t("warning.order.confirm_check_out");
      content = this.t.t("warning.order.confirm_tenant_out");
    }

    this.modal.confirm({
      nzTitle: title,
      nzContent: content,
      nzOnOk: () => {
        this.requestUpdateCheckStatus(code, out_status === "wait_stay" ? "staying_checkin" : "staying_checkout");
      },
    });
  }

  onClickAcceptButton(reservation) {
    this.requestApproveReservation(reservation.code).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchOrderList();
        this.msg.success(this.t.t("success.order.accept_order"));

        // this.globalModalService.displayTujiaAutoReceiptModal(code);
      } else {
        this.msg.warning(this.t.t("warning.order.accept_order_failed"));
      }
    });
  }

  onClickDeclineButton(reservation) {
    this.requestDeclineReservation(reservation.code).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchOrderList();
        this.msg.success(this.t.t("success.order.refuse_order"));
      } else {
        this.msg.warning(this.t.t("warning.order.refuse_order_failed"));
      }
    });
  }

  private requestApproveReservation(code) {
    const params = {
      reservation_code: code,
    };
    return this.orderService.approveReservation(params);
  }

  private requestDeclineReservation(code) {
    const params = {
      reservation_code: code,
    };
    return this.orderService.declineReservation(params);
  }

  private requestUpdateCheckStatus(code, status) {
    const params = {
      reservation_code: code,
      to_status: status,
    };
    this.orderService.handleStayingStatus(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchOrderList();
      }
    });
  }
}
